export default __webpack_public_path__ + "static/media/space-object-d.8550bec2.svg";